// extracted by mini-css-extract-plugin
export default {"container":"Consent_container__V5kEQ","header":"Consent_header__y8BUi","body":"Consent_body__gk9uC","content":"Consent_content__-UQwJ","stateButton":"Consent_stateButton__PJcxU"};